module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('mode-switcher', {
    attrs: {
      "backButtonBehaviors": _vm.backButtonBehaviors,
      "currentBackButtonBehavior": _vm.currentBackButtonBehavior,
      "onChangeBackButtonBehavior": _vm.changeBackButtonBehavior,
      "currentMode": _vm.currentMode,
      "availableModes": _vm.availableModes,
      "onChangeMode": _vm.changeMode,
      "switcherLayouts": _vm.switcherLayouts,
      "currentSwitcherLayout": _vm.currentSwitcherLayout,
      "onChangeSwitcherLayout": _vm.changeSwitcherLayout,
      "currentShowAllBehavior": _vm.currentShowAllBehavior,
      "showAllBehaviors": _vm.showAllBehaviors,
      "onChangeShowAllBehavior": _vm.changeShowAllBehavior,
      "currentAltClickMode": _vm.currentAltClickMode,
      "altClickModes": _vm.altClickModes,
      "onChangeAltClickMode": _vm.changeAltClickMode
    }
  }), _vm._v(" "), (_vm.currentSwitcherLayout === 'boxes') ? _c('app-context-switcher', {
    attrs: {
      "appHistory": _vm.appSwitcherItems,
      "show": _vm.showAppSwitcher,
      "tools": _vm.tools
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentApp.dropdown) ? _c('div', {
    staticClass: "app-vignette",
    on: {
      "click": _vm.closeDropdown
    }
  }) : _vm._e(), _vm._v(" "), _c('header', {
    staticClass: "app-header"
  }, [_c('app-breadcrumbs', {
    attrs: {
      "data": _vm.breadcrumbsWithDropdown,
      "currentApp": _vm.currentApp,
      "updateBreadcrumbs": _vm.updateBreadcrumbs,
      "toggleDropdown": _vm.toggleDropdown,
      "dropdownVisible": _vm.currentApp.dropdown,
      "tools": _vm.tools,
      "showBreadcrumbs": _vm.currentSwitcherLayout === 'boxes',
      "showAppSwitcher": _vm.showAppSwitcher
    }
  }), _vm._v(" "), (_vm.currentSwitcherLayout === 'tabs') ? _c('app-tabs', {
    attrs: {
      "appHistory": _vm.currentApp.appStateHistory,
      "tools": _vm.tools
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "app-header__end"
  }, [_c('div', {
    staticClass: "app-header__divider"
  }), _vm._v(" "), _c('section', {
    staticClass: "app-switcher"
  }, [_vm._l((_vm.routes), function(route, key) {
    return _c('app-icon-button', {
      key: key,
      class: ['app-switcher__button', _vm.currentRouteKey === key ? 'selected' : null],
      attrs: {
        "disabled": !route.appState,
        "prototype": route
      },
      on: {
        "click": function () {
          if (!route.appState) {
            return null;
          }
          return _vm.changeRoute(key);
        }
      }
    })
  }), _vm._v(" "), _c('app-icon-button', {
    class: ['app-switcher__button', 'app-switcher__button--popover'],
    attrs: {
      "prototype": {
        icon: require('./assets/icons/icon-chevron-down.svg')
      }
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "app-header__divider"
  }), _vm._v(" "), _c('section', {
    staticClass: "app-switcher"
  }, [_c('app-icon-button', {
    class: ['app-switcher__button', 'app-switcher__button--popover'],
    attrs: {
      "prototype": {
        icon: require('./assets/icons/icon-bookmark.svg')
      }
    }
  }), _vm._v(" "), _c('app-icon-button', {
    class: ['app-switcher__button', 'app-switcher__button--popover'],
    attrs: {
      "prototype": {
        icon: require('./assets/icons/icon-notifications.svg')
      }
    }
  }), _vm._v(" "), _c('app-icon-button', {
    class: ['app-switcher__button', 'app-switcher__button--popover'],
    attrs: {
      "prototype": {
        icon: require('./assets/icons/icon-folder.svg')
      }
    }
  }), _vm._v(" "), _c('app-icon-button', {
    class: ['app-switcher__button', 'app-switcher__button--popover'],
    attrs: {
      "prototype": {
        icon: require('./assets/icons/icon-chevron-down.svg')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "app-header__divider"
  }), _vm._v(" "), _c('app-icon-button', {
    class: ['app-switcher__button'],
    attrs: {
      "prototype": {
        icon: require('./assets/profile-picture.png')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('view-container', {
    attrs: {
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('app-toasts', {
    attrs: {
      "toasts": _vm.toasts,
      "tools": _vm.tools
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2799b945","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 435
// module chunks = 1